export default {
  musics: [],
  repertories: [],
  count: null,
  themes: []
};
